import * as React from 'react';
import Modal from 'antd/lib/modal';
import Space from 'antd/lib/space';
import Flex from 'antd/lib/flex';
import Text from 'antd/lib/typography/Text';
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { antGrey } from './styles/globalStyles';
import TooltipInfoIcon from './helperComponents/TooltipInfoIcon';

interface SkipReleaseModalProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: (shouldRollForwardMetadata: boolean) => void;
    isAndroid?: boolean;
}

export const SkipReleaseModal: React.FC<SkipReleaseModalProps> = ({ open, onCancel, onConfirm, isAndroid = false }) => {
    const [shouldRollForwardMetadata, setShouldRollForwardMetadata] = React.useState(true);

    const handleCheckboxChange = (event: CheckboxChangeEvent) => {
        setShouldRollForwardMetadata(event.target.checked);
    };

    const handleConfirm = () => {
        onConfirm(shouldRollForwardMetadata);
    };

    return (
        <Modal
            title="Are you sure you want to skip this release?"
            open={open}
            onCancel={onCancel}
            footer={(_, { CancelBtn }) => (
                <Space>
                    <CancelBtn />
                    <Button type="primary" onClick={handleConfirm}>
                        Yes, skip release
                    </Button>
                </Space>
            )}
            centered
            width={500}
            destroyOnClose
        >
            <Flex vertical gap={16} style={{ width: '100%' }}>
                <Text style={{ fontSize: 14, color: antGrey.grey8 }}>
                    The release record will stay in Runway but appear as skipped in the release timeline.
                </Text>

                <Flex align="center" gap={2}>
                    <Checkbox checked={shouldRollForwardMetadata} onChange={handleCheckboxChange}>
                        Roll forward metadata changes from this release
                    </Checkbox>
                    <TooltipInfoIcon
                        tooltipContent={`This will ensure that any metadata changes (${isAndroid ? 'Release notes' : "What's new"}, etc.) made to this release are applied to the next active release.`}
                    />
                </Flex>
            </Flex>
        </Modal>
    );
};
